import { ApplicationConfig, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection, inject } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './core/interceptors/auth.interceptors';
import { ModuleLockedInterceptor } from './core/interceptors/module-locked.interceptor';
import { AccesCoupeInterceptor } from './core/interceptors/acces-coupe.interceptor';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';

/** Fuseau d'affichage du caser (ex. « -1000 »), absent tant qu'il n'a pas été déclaré. */
const FUSEAU_CASER = (environment as { timezone?: string }).timezone;
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { fr } from "primelocale/fr.json";
import { MessageService } from 'primeng/api';
import { firstValueFrom, of } from 'rxjs';
import { ShopsStore } from './core/stores/shops.store';
import { AuthService } from './core/services/auth.service';
import { provideCustomAppMenuDefinition } from './custom/app-menu.custom.definition';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Précharge les chunks lazy en tâche de fond après le 1er rendu :
    // les apps du launcher deviennent quasi instantanées aux clics suivants.
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideHttpClient(withFetch(),withInterceptors([AuthInterceptor, ModuleLockedInterceptor, AccesCoupeInterceptor])),
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      if (!auth.isAuthenticated()) return firstValueFrom(of([]));
      return firstValueFrom(inject(ShopsStore).loadOnce());
    }),
    provideCustomAppMenuDefinition(),
    providePrimeNG({
        theme: {
            preset: Aura,
            options: { darkModeSelector: '.app-dark' }
        },
      translation: fr,
    }),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    // Toutes les dates du back-office se lisent dans le fuseau du caser, jamais dans
    // celui du navigateur : une séance à 10 h sur place doit s'afficher « 10:00 »
    // partout. Sans ce réglage, le même créneau apparaissait « 22:00 » depuis l'Europe,
    // et l'enregistrer depuis là-bas décalait la donnée.
    // `timezone` absent (caser n'ayant pas encore déclaré le sien) = objet vide : le
    // pipe retombe alors sur le fuseau du navigateur, comme avant ce réglage.
    //
    // Le champ est lu via une constante typée : `src/environments/` appartient à chaque
    // caser, la propriété n'existe pas partout, et un accès direct ne compilerait pas là
    // où elle manque.
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: FUSEAU_CASER ? { timezone: FUSEAU_CASER } : {} },
    MessageService,
    // `DatePipe` au niveau racine : un service partage (ex. OdigiDates) doit pouvoir
    // l'injecter pour formater dans le fuseau du caser. Les composants qui le
    // fournissent deja localement (KRATISI) ne sont pas affectes.
    DatePipe,
  ]
};
